// ***** DEV NOTES *****
// Any on-page state/actions should be optional parameters on the route
// Any global state (e.g. open modal) that could potentially apply to any
// page should be passed as query parameters so that they don't need defining
// on every route
// *********************

import Vue from 'vue'
import Router from 'vue-router'
import "vue-wysiwyg/dist/vueWysiwyg.css";

import { has, forEach } from 'lodash';


const Homepage = () =>
	import ( /* webpackChunkName: "home" */ '@/components/Homepage');

const PageNotFound = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/PageNotFound');
const Games = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/Games');
const PromotionalTools = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/PromotionalTools');
const AssetManager = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/AssetManager');
const Roadmap = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/Roadmap');
const Documents = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/Documents');
const NewsArchive = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/NewsArchive');
const NewsSingle = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/NewsSingle');
const PrivacyPolicy = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/PrivacyPolicy');
const TermsAndConditions = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/TermsAndConditions');

const Login = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/admin/Login');
const ResetPassword = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/admin/ResetPassword');
const SetPassword = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/admin/SetPassword');

const AboutUs = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/AboutUs');

const Casino = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/Casino');

const Sports = () =>
	import ( /* webpackChunkName: "frontend" */ '@/components/Sports');

const Admin = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/Admin');
const Dashboard = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/Dashboard');

const RouteThrough = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/RouteThrough');

const ViewGames = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/games/ViewGames');
const AddEditGame = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/games/AddEditGame');

const ViewUsers = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/users/ViewUsers');
const AddEditUser = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/users/AddEditUser');

const ViewOperators = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/operators/ViewOperators');
const AddEditOperator = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/operators/AddEditOperator');

const ViewPartners = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/partners/ViewPartners');
const AddEditPartner = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/partners/AddEditPartner');

const ViewCategories = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/categories/ViewCategories');
const AddEditCategory = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/categories/AddEditCategory');

const ManageDocuments = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/documents/ManageDocuments');

const ManageNews = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/news/ManageNews');
const AddEditNews = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/news/AddEditNews');

const ManageHomepage = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManageHomepage');

const ManageGamesPage = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManageGamesPage');

const ManagePromotionalTools = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManagePromotionalTools');

const ManageAssetManager = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManageAssetManager');

const ManageRoadmap = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManageRoadmap');

const ManageAboutUs = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManageAboutUs');

const ManageCasino = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManageCasino');

const ManageSports = () =>
	import ( /* webpackChunkName: "admin" */ '@/components/admin/pages/ManageSports');

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Homepage',
			component: Homepage,
			meta: {
				title: 'IGT Casino Lounge'
			}
		},
		{
			path: '/games/:activeGameId?/:activeTab?',
			name: 'Games',
			component: Games,
			props: true,
			meta: {
				title: 'Games',
				permission: {
					levels: {
						igt: ['AM', 'CM', 'SA'],
						operator: ['affiliate', 'customer', 'performance'],
					},
					redirect: {
						name: 'Login'
					}
				},
			}
		},
		{
			path: '/engagement-platform',
			name: 'PromotionalTools',
			component: PromotionalTools,
			props: true,
			meta: {
				title: 'Engagement Platform',
				/*permission: {
					levels: {
						igt: ['AM', 'CM', 'SA'],
						operator: ['affiliate', 'customer', 'performance'],
					},
					redirect: {
						name: 'Login'
					}
				},*/
			}
		},
		{
			path: '/asset-manager/:initialFolderId?',
			name: 'AssetManager',
			component: AssetManager,
			props: true,
			meta: {
				title: 'Asset Manager',
				permission: {
					levels: {
						igt: ['AM', 'CM', 'SA'],
						operator: ['affiliate', 'customer', 'performance'],
					},
					redirect: {
						name: 'Login'
					}
				},
			},
		},
		{
			path: '/roadmap',
			name: 'Roadmap',
			component: Roadmap,
			meta: {
				title: 'Roadmap',
				hasFooter: false,
			},
		},
		{
			path: '/documents/:initialFolderId?',
			name: 'Documents',
			component: Documents,
			props: true,
			meta: {
				title: 'Documents',
				permission: {
					levels: {
						igt: ['AM', 'CM', 'SA'],
						operator: ['customer', 'performance'],
					},
					redirect: {
						name: 'Login'
					}
				},
			}
		},
		{
			path: '/news-events/:category?',
			name: 'NewsArchive',
			component: NewsArchive,
			meta: {
				title: 'News and Events',
				isHeaderFilled: true
			},
		},
		{
			path: '/news-events/post/:id',
			name: 'NewsSingle',
			component: NewsSingle,
			props: true,
			meta: {
				title: 'News Item',
				isHeaderFilled: true
			},
		},
		{
			path: '/privacy-policy',
			name: 'PrivacyPolicy',
			component: PrivacyPolicy,
			meta: {
				title: 'Privacy Policy',
				isHeaderFilled: true,
			},
		},
		{
			path: '/aboutus',
			name: 'AboutUs',
			component: AboutUs,
			props: true,
			meta: {
				title: 'About Us'
			},
		},
		{
			path: '/casino',
			name: 'Casino',
			component: Casino,
			props: true,
			meta: {
				title: 'Casino'
			},
		},
		{
			path: '/sports',
			name: 'Sports',
			component: Sports,
			props: true,
			meta: {
				title: 'Sports'
			},
		},
		{
			path: '/terms-and-conditions',
			name: 'TermsAndConditions',
			component: TermsAndConditions,
			meta: {
				title: 'Terms and Conditions',
				isHeaderFilled: true,
			},
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				title: 'Login',
				isHeaderFilled: true,
			},
		},
		{
			path: '/set-password/:token',
			name: 'SetPassword',
			component: SetPassword,
			props: true,
			meta: {
				title: 'Set Password',
				isHeaderFilled: true,
			},
		},
		{
			path: '/reset-password',
			name: 'ResetPassword',
			component: ResetPassword,
			meta: {
				title: 'Reset Password',
				isHeaderFilled: true,
			},
		},
		{
			path: '/admin',
			component: Admin,
			meta: {
				breadcrumb: 'Dashboard',
				permission: {
					levels: {
						igt: ['SA']
					},
					redirect: {
						name: 'Login'
					}
				},
				isAdmin: true
			},
			children: [
				{
					path: '',
					name: 'Dashboard',
					component: Dashboard,
					meta: {
						title: 'Welcome back'
					},
				},
				{
					path: 'games',
					component: RouteThrough,
					meta: {
						breadcrumb: 'Games',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
					children: [
						{
							path: '',
							name: 'ManageGames',
							component: ViewGames,
							meta: {
								title: 'Manage games',
								addAction: {
									'text': 'Add a game',
									'route': 'AddGame'
								}
							},
						},
						{
							path: 'add',
							name: 'AddGame',
							component: AddEditGame,
							meta: {
								breadcrumb: 'Add a Game',
								title: 'Add a game'
							},
						},
						{
							path: 'edit/:id',
							name: 'EditGame',
							component: AddEditGame,
							props: true,
							meta: {
								breadcrumb: 'Edit Game',
								title: 'Edit game'
							},
						}
					]
				},
				{
					path: 'users',
					component: RouteThrough,
					meta: {
						breadcrumb: 'Users',
						permission: {
							levels: {
								igt: ['AM', 'SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
					children: [
						{
							path: '',
							name: 'ManageUsers',
							component: ViewUsers,
							meta: {
								title: 'Manage users',
								addAction: {
									'text': 'Add a user',
									'route': 'AddUser'
								}
							},
						},
						{
							path: 'add',
							name: 'AddUser',
							component: AddEditUser,
							meta: {
								breadcrumb: 'Add a User',
								title: 'Add a user'
							},
						},
						{
							path: 'edit/:id',
							name: 'EditUser',
							component: AddEditUser,
							props: true,
							meta: {
								breadcrumb: 'Edit User',
								title: 'Edit user'
							},
						}
					]
				},
				{
					path: 'operators',
					component: RouteThrough,
					meta: {
						breadcrumb: 'Operators',
						permission: {
							levels: {
								igt: ['AM', 'SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
					children: [
						{
							path: '',
							name: 'ManageOperators',
							component: ViewOperators,
							meta: {
								title: 'Manage operators',
								addAction: {
									'text': 'Add an operator',
									'route': 'AddOperator'
								}
							},
						},
						{
							path: 'add',
							name: 'AddOperator',
							component: AddEditOperator,
							meta: {
								breadcrumb: 'Add an Operator',
								title: 'Add an operator'
							},
						},
						{
							path: 'edit/:id',
							name: 'EditOperator',
							component: AddEditOperator,
							props: true,
							meta: {
								breadcrumb: 'Edit Operator',
								title: 'Edit operator'
							},
						}
					]
				},
				{
					path: 'partners',
					component: RouteThrough,
					meta: {
						breadcrumb: 'Partners',
						permission: {
							levels: {
								igt: ['AM', 'SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
					children: [
						{
							path: '',
							name: 'ManagePartners',
							component: ViewPartners,
							meta: {
								title: 'Manage partners',
								addAction: {
									'text': 'Add a partner',
									'route': 'AddPartner'
								}
							},
						},
						{
							path: 'add',
							name: 'AddPartner',
							component: AddEditPartner,
							meta: {
								breadcrumb: 'Add a Partner',
								title: 'Add a partner'
							},
						},
						{
							path: 'edit/:id',
							name: 'EditPartner',
							component: AddEditPartner,
							props: true,
							meta: {
								breadcrumb: 'Edit Partner',
								title: 'Edit partner'
							},
						}
					]
				},
				{
					path: 'categories',
					component: RouteThrough,
					meta: {
						breadcrumb: 'Categories',
						permission: {
							levels: {
								igt: ['AM', 'SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
					children: [
						{
							path: '',
							name: 'ManageCategories',
							component: ViewCategories,
							meta: {
								title: 'Manage categories',
								addAction: {
									'text': 'Add a category',
									'route': 'AddCategory'
								}
							},
						},
						{
							path: 'add',
							name: 'AddCategory',
							component: AddEditCategory,
							meta: {
								breadcrumb: 'Add a Category',
								title: 'Add a category'
							},
						},
						{
							path: 'edit/:id',
							name: 'EditCategory',
							component: AddEditCategory,
							props: true,
							meta: {
								breadcrumb: 'Edit Category',
								title: 'Edit category'
							},
						}
					]
				},
				{
					path: 'documents',
					name: 'ManageDocuments',
					component: ManageDocuments,
					meta: {
						title: 'Manage documents',
						breadcrumb: 'Documents',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'news-and-events',
					component: RouteThrough,
					meta: {
						breadcrumb: 'News & Events',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
					children: [
						{
							path: '',
							name: 'ManageNews',
							component: ManageNews,
							meta: {
								title: 'Manage news',
								addAction: {
									'text': 'Add news',
									'route': 'AddNews'
								}
							},
						},
						{
							path: 'add',
							name: 'AddNews',
							component: AddEditNews,
							meta: {
								breadcrumb: 'Add News',
								title: 'Add News'
							},
						},
						{
							path: 'edit/:id',
							name: 'EditNews',
							component: AddEditNews,
							props: true,
							meta: {
								breadcrumb: 'Edit News',
								title: 'Edit news'
							},
						}
					]
				},
				{
					path: 'homepage',
					name: 'ManageHomepage',
					component: ManageHomepage,
					meta: {
						title: 'Manage homepage',
						breadcrumb: 'Homepage',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'games-page',
					name: 'ManageGamesPage',
					component: ManageGamesPage,
					meta: {
						title: 'Manage games page',
						breadcrumb: 'Games Page',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'engagementplatform',
					name: 'ManagePromotionalTools',
					component: ManagePromotionalTools,
					meta: {
						title: 'Manage promotional tools',
						breadcrumb: 'Promotional tools',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'asset-manager',
					name: 'ManageAssetManager',
					component: ManageAssetManager,
					meta: {
						title: 'Manage asset manager',
						breadcrumb: 'Asset Manager',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'roadmap',
					name: 'ManageRoadmap',
					component: ManageRoadmap,
					meta: {
						title: 'Manage roadmap',
						breadcrumb: 'Roadmap',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'aboutus',
					name: 'ManageAboutUs',
					component: ManageAboutUs,
					meta: {
						title: 'Manage About Us',
						breadcrumb: 'About Us',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'casino',
					name: 'ManageCasino',
					component: ManageCasino,
					meta: {
						title: 'Manage Casino',
						breadcrumb: 'Casino',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				},
				{
					path: 'sports',
					name: 'ManageSports',
					component: ManageSports,
					meta: {
						title: 'Manage Sports',
						breadcrumb: 'Sports',
						permission: {
							levels: {
								igt: ['SA']
							},
							redirect: {
								name: 'Dashboard'
							}
						},
					},
				}
			]
		},
		{
			path: '*',
			name: 'PageNotFound',
			component: PageNotFound
		},
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition)
		{
			return savedPosition
		}
		else
		{
			// Do nothing if we're within a common parent route on the frontend
			if((!has(from, 'matched.0.meta.isAdmin') || from.matched[0].meta.isAdmin !== true) && has(from, 'matched.0') && has(to, 'matched.0') && from.matched[0].name === to.matched[0].name)
			{
				return false;
			}
			else
			{
				return { x: 0, y: 0 }
			}
		}
	}
})


router.beforeEach((to, from, next) => {

	// Authentication
	var hasPermission = true;
	var redirect = {
		name: 'Homepage'
	};

	forEach(to.matched, function(record)
	{
		// This route requires auth, check if logged in
		// If not, redirect to login page.
		if(record.meta.permission)
		{
			// BUG - this doesn't work on first page load. See:
			// https://forum.vuejs.org/t/accessing-root-instance-data-methods-on-beforeeach-guards/6148
			if (has(router, 'app.$root.userHasPermission'))
			{
				if(!router.app.$root.userHasPermission(record.meta.permission.levels))
				{
					hasPermission = false;
					redirect = record.meta.permission.redirect;
					return false;
				}
			}
			// On first page load, store on the route and process when the app loads
			else
			{
				if(!has(to, 'onloadPermissions'))
				{
					to.meta.onloadPermissions = [];
				}
				to.meta.onloadPermissions.push(record.meta.permission);
			}
		}
	});

	if (!hasPermission && redirect)
	{
		next(redirect)
	}


	// Is admin?
	if (to.matched.some(record => record.meta.isAdmin))
	{
		to.meta.isAdmin = true;
	}
	// So front-end then. Show loading screen
	else
	{
		if(has(router, 'app.$root.$data'))
		{
			// If not a child page ...
			if(!has(from, 'matched.0') || !has(to, 'matched.0')|| from.matched[0].name !== to.matched[0].name)
			{
				router.app.$root.$data.appLoading = true;
			}
		}
	}


	// Document title
	if(has(to, 'meta.title') && to.meta.title)
	{
		document.title = to.meta.title;
	}


	// Make sure to always call next()!
	next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js